import React from 'react';

import type {ScientificModelNode} from 'model-hub/scientific-models/ScientificModelMetadata';

export function AlphaFoldPaperLink({model}: {model: ScientificModelNode}): JSX.Element {
  return (
    <a href={model.paperLink} target="_blank" rel="noopener noreferrer">
      {model.displayName}
    </a>
  );
}
